import { render, staticRenderFns } from "./DoseType.vue?vue&type=template&id=49b2648f&scoped=true&"
import script from "./DoseType.vue?vue&type=script&lang=js&"
export * from "./DoseType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b2648f",
  null
  
)

export default component.exports